import type {
  InterstateOnChangeEvent,
  NumericInputProps,
  TextInputProps
} from "@dealer-center/core-components";
import {
  Box,
  Button,
  CopyToClipboardIcon,
  EmailIcon,
  OpenInNewTabIcon,
  TextInput
} from "@dealer-center/core-components";
import { StyledPagesLandingPageListItem } from "./styles";
import React from "react";

interface PagesLandingPageListItemProps {
  label: string;
  value?: string | null | undefined | number | boolean | React.ReactElement;
  type?: "externalLink" | "copyToClipboard" | "email" | "disabledInput";
  name?: string;
}
interface PagesLandingPageListItemEditableProps {
  label: string;
  value?: number | string | null;
  name?: string;
  type?: "editableText" | "editableNumber" | "eventuallyEditable";
  inputProps?: Partial<TextInputProps | NumericInputProps>;
  onChange: (value: InterstateOnChangeEvent<string>) => void;
}

export const PagesLandingPageListItem = (
  props: PagesLandingPageListItemProps | PagesLandingPageListItemEditableProps
) => {
  if (
    !props.value &&
    props.type !== "editableText" &&
    props.type !== "editableNumber" &&
    props.type !== "eventuallyEditable" &&
    props.type !== "disabledInput"
  )
    return null;

  // Check if value is a React element
  const isReactElement = React.isValidElement(props.value);

  return (
    <StyledPagesLandingPageListItem>
      {isReactElement ? (
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              color: "rgba(0, 0, 0, 0.6)",
              fontSize: "0.75rem",
              marginBottom: "4px"
            }}
          >
            {props.label}
          </Box>
          {props.value}
        </Box>
      ) : (
        <TextInput
          disabled={props.type === "disabledInput"}
          label={props.label}
          name={props.name || props.label}
          readOnly={
            props.type !== "editableText" &&
            props.type !== "editableNumber" &&
            props.type !== "disabledInput"
          }
          size="small"
          sx={{
            height: "auto",
            padding: 0,
            "& *": {
              "& *": {
                padding: "0.3px"
              }
            }
          }}
          value={props.value as string}
          onChange={e => {
            if (
              props.type === "editableText" ||
              props.type === "editableNumber"
            )
              props.onChange(e);
          }}
        />
      )}
      {props.type === "externalLink" && (
        <Button
          analyticsConfiguration={{
            eventName: `open_external_link_${props.label}`
          }}
          buttonStyle="tertiary"
          icon={<OpenInNewTabIcon title="Open in new tab" />}
          onClick={() => window.open(props.value as string)}
        />
      )}
      {props.type === "copyToClipboard" && (
        <Button
          analyticsConfiguration={{
            eventName: `copy_to_clipboard_${props.label}`
          }}
          buttonStyle="tertiary"
          icon={<CopyToClipboardIcon title="Copy to clipboard" />}
          onClick={() => navigator.clipboard.writeText(props.value as string)}
        />
      )}
      {props.type === "email" && (
        <Button
          analyticsConfiguration={{
            eventName: `send_email_${props.label}`
          }}
          buttonStyle="tertiary"
          icon={<EmailIcon title="Send email" />}
          onClick={() => window.open(`mailto:${props.value}`)}
        />
      )}
    </StyledPagesLandingPageListItem>
  );
};
